import { RegistrationPurchaseType } from '~/types/vat-bookkeeping';
import { Counterpart } from './counterparts';

export const RegistrationTemplateResourceType = 'registration-template';

export enum RegistrationTemplateType {
  BOOKKEEPING_TRANSACTION = 'BOOKKEEPING_TRANSACTION',
  VAT_REGISTRATION_ISSUED = 'VAT_REGISTRATION_ISSUED',
  VAT_REGISTRATION_RECEIVED = 'VAT_REGISTRATION_RECEIVED',
}

export const RegistrationTemplateQueryKeys = {
  company: (companyId: string) => ['RegistrationTemplates', companyId],
  list: (companyId: string) => ['RegistrationTemplates', companyId, 'List'],
};

interface BaseRegistrationTemplate {
  id: string;
  companyId: string;
  name: string;
}

interface BookkeepingTransactionTemplateBodyEntry {
  bookkeepingAccountId?: string | null;
  counterpartId?: Counterpart['id'] | null;
  description?: string | null;
}

interface BookkeepingTransactionTemplateView {
  descriptionColumn: boolean;
  competencePeriodColumn: boolean;
}

export interface BookkeepingTransactionTemplateBody {
  description?: string | null;
  view: BookkeepingTransactionTemplateView;
  entries: BookkeepingTransactionTemplateBodyEntry[];
}

interface VATRegistrationTemplateBodyEntry {
  bookkeepingAccountId?: string | null;
  vatCodeId?: string | null;
  purchaseType?: RegistrationPurchaseType | null;
}

interface VATRegistrationTemplateView {
  purchasePeriod: boolean;
}

export interface VATRegistrationTemplateBody {
  description?: string | null;
  view: VATRegistrationTemplateView;
  registration: {
    bookkeepingAccountId?: string | null;
    counterpartId?: string | null;
  };
  entries: VATRegistrationTemplateBodyEntry[];
}

interface BookkeepingRegistrationTemplateData {
  templateType: RegistrationTemplateType.BOOKKEEPING_TRANSACTION;
  body: BookkeepingTransactionTemplateBody;
}

interface VATRegistrationIssuedTemplateData {
  templateType: RegistrationTemplateType.VAT_REGISTRATION_ISSUED;
  body: VATRegistrationTemplateBody;
}

interface VATRegistrationReceivedTemplateData {
  templateType: RegistrationTemplateType.VAT_REGISTRATION_RECEIVED;
  body: VATRegistrationTemplateBody;
}

export type RegistrationTemplateData =
  | BookkeepingRegistrationTemplateData
  | VATRegistrationIssuedTemplateData
  | VATRegistrationReceivedTemplateData;

type BookkeepingRegistrationTemplate = BaseRegistrationTemplate & BookkeepingRegistrationTemplateData;
type VATRegistrationIssuedTemplate = BaseRegistrationTemplate & VATRegistrationIssuedTemplateData;
type VATRegistrationReceivedTemplate = BaseRegistrationTemplate & VATRegistrationReceivedTemplateData;

export type RegistrationTemplate =
  | BookkeepingRegistrationTemplate
  | VATRegistrationIssuedTemplate
  | VATRegistrationReceivedTemplate;
export type RegistrationTemplateCreate = { name: string } & RegistrationTemplateData;
